<template>
<v-layout>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs6 md3 class="text-xs-left">
        <v-btn href="#/network/addUrl" color="info" @click="goToAdd()">Add Network Url</v-btn>
      </v-flex>

      <v-flex xs6 md3 class="text-xs-left">
        <v-btn color="info" @click="loadAllNetworkUrls">Load All Offers</v-btn>
      </v-flex>
      
      <v-flex xs12 md6>
        <v-layout row wrap>
          <v-flex xs6>
            <div style="display: flex; margin-left: 10px;">
              <v-text-field
                v-model="editNetworkUrlId"
                label="Offer Id"
              ></v-text-field>
              <v-btn small fab color="info" @click="editNetworkUrlByNetworkUrlId">
                <v-progress-circular v-if="loadingNetworkUrlDetails" indeterminate color="white" :size="30"></v-progress-circular>
                <v-icon v-else small>edit</v-icon>
              </v-btn>
            </div>
          </v-flex>
          
          <v-flex xs6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search in table below..."
              single-line
              hide-details
              style="margin-right: 10px;"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="networkUrls"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-right" style="cursor: pointer;" @click="showOfferDetailsHander(props.item)">{{ props.item.networkUrlId }}</td>

        <td @click="changeAdvertiserUrl(props.item)" style="cursor: pointer">
          <v-icon>link</v-icon> 
        </td>

        <td @click="changeNetworkUrlFilter(props.item)"  style="cursor: pointer">
          <a>{{ props.item.filter }}</a>
        </td>

        <td class="text-xs-left">{{ props.item.networkName }}</td>
        <td class="text-xs-left">{{ props.item.countryName }}</td>
        <td class="text-xs-left">{{ props.item.operatorName }}</td>

        <td class="text-xs-left">{{ props.item.trafficType }}</td>
        <td class="text-xs-left">{{ props.item.modelType }}</td>
        <td class="text-xs-left">{{ props.item.advertiserCampaignName }}({{ props.item.advertiserUrlId }})</td>

        <td class="text-xs-left">
            {{ props.item.advertiserUrl }}
        </td>
        
        <td class="text-xs-left">{{ props.item.payout }}</td>
        <td class="text-xs-left">{{ props.item.status ? 'Active' : 'Inactive' }}</td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editNetworkUrlDetails(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteNetworkUrl(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
        
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Sorry!!! No result found for your search "{{ search }}".
      </v-alert>
    </v-data-table>
  </v-flex>

  <v-flex>
    <v-dialog v-model="editNetworkUrlDialog" max-width="500px">
        <v-card>
          <v-card-title>
            Edit Network Url
          </v-card-title>
          <v-card-text>

            <v-text-field
                v-model="postbackUrl"
                hide-details
                single-line
              ></v-text-field>

            <v-text-field
              type="number"
              v-model="changedPayout"
              label="Payout($)"
            ></v-text-field>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.stop="updateNetowrkUrlChanges();">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-flex>

  <v-flex>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            Change Advertiser Url
          </v-card-title>
          <v-card-text>

            <v-text-field
              v-if="selectedNetworkUrl"
              :value="selectedNetworkUrl.networkUrlId"
              label="Offer Id"
              disabled
            ></v-text-field>

            <v-text-field
              v-if="selectedNetworkUrl"
              :value="getCampaignAndAdvertiserUrlId"
              label="CampaignName"
              disabled
            ></v-text-field>

            <v-text-field
              v-if="selectedNetworkUrl"
              :value="selectedNetworkUrl.advertiserUrl"
              label="Advertiser Url"
              disabled
            ></v-text-field>

            <v-autocomplete
              :items="advertiserUrlList"
              :search-input.sync="searchAdvUrl"
              v-model="advertiserUrl"
              single-line
              hide-details
              label="Search Advertiser Url"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.stop="saveChangeUrl();">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-flex>

  <v-flex v-if="deleteDialog">
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Do you want to change the status of the network url?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click.native="deleteDialog = false; selectedNetworkUrl = null">Cancel</v-btn>
          <v-btn color="primary" outline @click.native="deleteConfirmed()">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>

  <v-flex v-if="showOfferDetails">
    <v-dialog v-model="showOfferDetails" persistent max-width="450">
      <v-card>
        <v-card-title class="subtitle" style="margin: 10px;">
          Offer Id : {{ OfferDetails.id }} <br/>
          Country: {{ OfferDetails.country }} <br/>
          Operator : {{ OfferDetails.operator }} <br/>
          Traffic Type:- {{ OfferDetails.trafficType }}<br/>
          payout:- {{ OfferDetails.payout }}<br/>
          Cap:- Open<br/>
          Flow:- 1 Click<br/>
          Allow:- Iframe<br/>
          Offer Url : {{ OfferDetails.url }} <br/>
          Preview Url : 
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click.native="showOfferDetails = false;">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>

  <v-flex v-if="showEditFilter">
    <v-dialog v-model="showEditFilter" persistent max-width="400">
      <v-card>
        <v-card-title class="subtitle">Change Filter Setting : &nbsp; &nbsp;&nbsp;
          <v-flex
            shrink
            style="width: 60px"
          >
          <v-text-field
                v-model="changedFilter"
                class="mt-0"
                hide-details
                single-line
                type="number"
              ></v-text-field>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-flex>
            
            <v-flex xs12>
              <v-slider
                v-model="changedFilter"
                thumb-label="always"
              ></v-slider>
            </v-flex>
          </v-flex>
        </v-card-text>
        <v-card-actions>

          <v-spacer></v-spacer>
          <v-btn color="secondary" outline @click.native="showEditFilter = false;">Cancel</v-btn>
          <v-btn color="primary" outline @click.native="changeNetworkUrlFilterHandler()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>

  </v-layout>
</template>
<script>
import axios from "axios";

import { SERVER_URL, API_SERVER_URL } from "@/constant.js";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Id",
          value: "networkUrlId",
          align: "left"
        },
        {
          text: "Change Url",
          align: "center",
          value: "advertiserUrl",
          sortable: false
        },
        {
          text: "Change Filter",
          align: "center",
          value: "filterChange",
          sortable: false
        },
        {
          text: "Network",
          value: "networkName",
          align: "left"
        },
        {
          text: "Country",
          align: "left",
          value: "countryName",
          sortable: false
        },
        {
          text: "Operator",
          align: "left",
          value: "operatorName",
          sortable: false
        },
        {
          text: "Traffic",
          align: "left",
          value: "trafficType",
          sortable: false
        },
        {
          text: "Model",
          align: "left",
          value: "modelType",
          sortable: false
        },
        {
          text: "Campaign",
          align: "left",
          value: "advertiserCampaignName",
          sortable: false
        },
        {
          text: "Adv. Url",
          align: "left",
          value: "changeAdvUrl",
          sortable: false
        },

        {
          text: "Payout",
          align: "left",
          value: "payout",
          sortable: false
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false
        }
      ],
      selectedNetworkUrl: null,
      networkUrls: [],

      advertiserUrl: "",
      advertiserUrls: [],
      advertiserUrlListMaster: [],
      advertiserUrlList: [],

      dialog: false,
      editDialog: false,
      deleteDialog: false,

      showOfferDetails: false,
      OfferDetails: {
        id: null,
        country: '',
        operator: '',
        url: '',
        trafficType: '',
        payout: '',
      },

      loading: false,
      searchAdvUrl: null,

      showEditFilter: false,
      changedFilter: 0,

      changedPayout: 0,
      postbackUrl: '',
      editNetworkUrlDialog: false,

      editNetworkUrlId: null,

      loadingNetworkUrlDetails: false
      

    };
  },
  computed:{
    getCampaignAndAdvertiserUrlId () {
      return this.selectedNetworkUrl.advertiserCampaignName + "(" + this.selectedNetworkUrl.advertiserUrlId + ")";
    }
  },
  watch: {
    searchAdvUrl (val) {
      if (val) this.querySelections(val)
    }
  },
  created() {
    document.title = 'Network Urls';
    // axios.get(`${SERVER_URL}/network/allUrl`)
    // .then(res => {
    //   if(res) {
    //     this.networkUrls = res.data;
    //   }
    // })
  },
  methods: {
    loadAllNetworkUrls () {
       axios.get(`${SERVER_URL}/network/allUrl`)
      .then(res => {
        if(res) {
          this.networkUrls = res.data;
        }
      })
    },

    editNetworkUrlByNetworkUrlId () {
      if (!this.editNetworkUrlId || isNaN(this.editNetworkUrlId)) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Invalid/Blank Offer Id."
        });
        document.dispatchEvent(showSnackbarEvent);
        this.editNetworkUrlId = null;
        return;
      }
      this.loadingNetworkUrlDetails = true; 
      axios.get(`${SERVER_URL}/network/url/${this.editNetworkUrlId}`)
      .then(res => {
        if (res && res.data) {
          this.changeAdvertiserUrl(res.data);
        } else {
          var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
            detail: "Invalid Offer Id."
          });
          document.dispatchEvent(showSnackbarEvent);
          this.editNetworkUrlId = null;
        }
      });



      // let netUrl = this.networkUrls.find(val => val.networkUrlId == this.editNetworkUrlId);
      // if (netUrl) {
      //   console.log("selectedNetworkUrl: ", netUrl);
      //   this.changeAdvertiserUrl(netUrl);
      // } else {
      //   console.log("No networkUrl found.");
      //   var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
      //     detail: "Invalid Network URL Id."
      //   });
      //   document.dispatchEvent(showSnackbarEvent);
      //   this.editNetworkUrlId = null;
      // }

    },
    querySelections(val) {
      this.advertiserUrlList = this.advertiserUrlListMaster.filter(advUrl =>  advUrl.search(new RegExp(val, 'i')) > -1);
    },
    showOfferDetailsHander(networkUrl) {
      this.OfferDetails.id = networkUrl.networkUrlId;
      this.OfferDetails.country = networkUrl.countryName;
      this.OfferDetails.operator = networkUrl.operatorName;
      this.OfferDetails.url = `${API_SERVER_URL}/api/click.php?offer_id=${networkUrl.networkUrlId}&aff_id=${networkUrl.networkId}&${networkUrl.clickIdParameter}=YOUR_CLICK_ID&pubid=YOUR_PUBLISHER_ID&gaid=GoogleAdvertisingID&sub1=VARIABLE1&sub2=VARIABLE2&sub3=VARIABLE3&droidid=androidID&idfa=IphoneID`;
      this.OfferDetails.payout = networkUrl.payout
      this.OfferDetails.trafficType = networkUrl.trafficType;
      this.showOfferDetails = true;
    },
    advUrlComparator(a,b) {
      if (a.advertiserName < b.advertiserName)
        return -1;
      if (a.advertiserName > b.advertiserName)
        return 1;
      return 0;
    },
    goToAdd() {
      this.$router.push("/network/addurl");
    },
    editNetworkUrl(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.editDialog = true;
    },
    updateNetworkUrl() {
      axios
        .post(`${SERVER_URL}/network/updateUrl`, this.selectedNetworkUrl)
        .then(res => {
          var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
            detail: "Network Url Updated Successfully"
          });
          document.dispatchEvent(showSnackbarEvent);
          this.editDialog = true;
          var changedIndex = this.networkUrls.findIndex(
            netUrl =>
              netUrl.networkUrlId === this.selectedNetworkUrl.networkUrlId
          );
          this.$set(this.networkUrls, changedIndex, this.selectedNetworkUrl);
          this.selectedNetworkUrl = null;
        });
    },
    deleteNetworkUrl(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.deleteDialog = true;
    },
    deleteConfirmed() {
      
      let networkUrl = this.selectedNetworkUrl;

      networkUrl.status = ! networkUrl.status;
      this.deleteDialog = false;
      axios
      .post(`${SERVER_URL}/network/url/update`, networkUrl)
      .then(res => {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Deleted Successfully"
        });
        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = this.networkUrls.findIndex(
          netUrl =>
            netUrl.networkUrlId === networkUrl.networkUrlId
        );
        this.$set(this.networkUrls, changedIndex, networkUrl);
        this.selectedNetworkUrl = null;
      });
    },
    changeNetworkUrlFilter(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.changedFilter = networkUrl.filter;
      this.showEditFilter = true;
    },
    changeNetworkUrlFilterHandler () {
      this.showEditFilter = false;
      if (this.selectedNetworkUrl.filter === this.changedFilter) {
        this.selectedNetworkUrl = null;
        this.changedFilter = 0;
      } else {
        let networkUrl = this.selectedNetworkUrl;
        networkUrl.filter = this.changedFilter;
        axios
        .post(`${SERVER_URL}/network/url/update`, networkUrl)
        .then(res => {
          var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
            detail: "Network Url Filter Updated Successfully"
          });
          document.dispatchEvent(showSnackbarEvent);
          var changedIndex = this.networkUrls.findIndex(
            netUrl =>
              netUrl.networkUrlId === networkUrl.networkUrlId
          );
          this.$set(this.networkUrls, changedIndex, networkUrl);
          this.changedFilter = 0;
          this.selectedNetworkUrl = null;
        });
      }
    },
    changeAdvertiserUrl(networkUrl) {
      
      this.selectedNetworkUrl = networkUrl;
      this.advertiserUrls = [];
      this.advertiserUrlListMaster = [];
      this.advertiserUrlList.length = 0;

      axios.get(`${SERVER_URL}/advertiser/urls/byOperatorId/${networkUrl.operatorId}`)
      .then(res => {
        res.data.sort(this.advUrlComparator).forEach(val => {
          this.advertiserUrls.push(val);
          this.advertiserUrlListMaster.push(val.advertiserUrlId + " - " + val.advertiserCampaignName)
          this.advertiserUrlList.push(val.advertiserUrlId + " - " + val.advertiserCampaignName);
          this.dialog = true;
          this.loadingNetworkUrlDetails = false; 
        });
      });
    },
    saveChangeUrl() {

      if(!this.advertiserUrl) {
        this.dialog = false;
        return;
      }

      var advertiserUrlId = parseInt(
        this.advertiserUrl.substr(0, this.advertiserUrl.indexOf(" - "))
      );

      var selectedAdvertiserUrl = this.advertiserUrls.find(advUrl => {
        return advUrl.advertiserUrlId === advertiserUrlId;
      });

      this.selectedNetworkUrl.advertiserCampaignName = selectedAdvertiserUrl.advertiserCampaignName;
      this.selectedNetworkUrl.advertiserUrlId = selectedAdvertiserUrl.advertiserUrlId;
      this.selectedNetworkUrl.advertiserUrl = selectedAdvertiserUrl.advertiserUrl;
      this.selectedNetworkUrl.advertiserId = selectedAdvertiserUrl.advertiserId;
      this.selectedNetworkUrl.advertiserName = selectedAdvertiserUrl.advertiserName;

      axios
      .post(`${SERVER_URL}/network/url/update`, this.selectedNetworkUrl)
      .then(res => {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Updated Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);

        this.dialog = false;

        var changedIndex = this.networkUrls.findIndex(
          netUrl =>
            netUrl.networkUrlId === this.selectedNetworkUrl.networkUrlId
        );

        this.$set(this.networkUrls, changedIndex, this.selectedNetworkUrl);
        
        this.selectedNetworkUrl = null;
        this.advertiserUrl = "";
      });
    },
    editNetworkUrlDetails(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.changedFilter = networkUrl.filter;
      this.changedPayout = networkUrl.payout;
      this.postbackUrl = networkUrl.postbackUrl;
      this.editNetworkUrlDialog = true;
    },
    updateNetowrkUrlChanges() {

      this.editNetworkUrlDialog = false;

      let isEdited = false;

      if (this.selectedNetworkUrl.postbackUrl !== this.postbackUrl){
        isEdited = true;
        this.selectedNetworkUrl.postbackUrl = this.postbackUrl;
      } 
      
      if (this.selectedNetworkUrl.payout !== this.changedPayout) {
        isEdited = true;
        this.selectedNetworkUrl.payout = this.changedPayout;
      }


        
      if (isEdited)
      axios
      .post(`${SERVER_URL}/network/url/update`, this.selectedNetworkUrl)
      .then(res => {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Updated Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        this.dialog = false;

        var changedIndex = this.networkUrls.findIndex(
          netUrl =>
            netUrl.networkUrlId === this.selectedNetworkUrl.networkUrlId
        );

        this.$set(this.networkUrls, changedIndex, this.selectedNetworkUrl);

        this.selectedNetworkUrl = null;
        this.changedPayout = 0;
        this.postbackUrl = '';

      });

    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/network/ListNetworkUrl.vue